import httpClient from 'api/httpClient';
import { NDATemplate } from 'models/Nda';
import publicHttpClient from 'api/publicHttpClient';
import { ContactUsFormValues } from 'router/subrouters/Dash/pages/ContactUs/components/ContactUsForm/ContactUsForm.component';
import { ReferFriendFormType } from 'components/FooterWrapper/components/ReferAFriend/ReferAFriend.component';
import { FilePreview } from 'models/File';
import { DealRoomSearchResults } from 'models/Search';

function contactUs(data: ContactUsFormValues) {
  return publicHttpClient.post('generals/contact-us', data);
}

function referAFriend(data: ReferFriendFormType) {
  return httpClient.post('generals/refer-a-friend', data);
}

function getDocusignUrl(
  envelopeId: string,
  signerEmail: string,
  signerName: string,
  listingEnquiryId: string,
) {
  return publicHttpClient.get<{ url: string }>(
    `third-party/docusign/url/${envelopeId}`,
    {
      params: {
        signerEmail,
        signerName,
        listingEnquiryId,
      },
    },
  );
}

function searchMarketPlace(searchString: string) {
  return publicHttpClient.get<DealRoomSearchResults>('searches', {
    params: { searchString },
  });
}

function searchDeals(searchString: string) {
  return httpClient.get<DealRoomSearchResults>('searches', {
    params: { searchString },
  });
}

function getNdaTemplates() {
  return httpClient.get<NDATemplate[]>('docusign/templates');
}

function getArchivedNdaTemplates() {
  return httpClient.get<NDATemplate[]>('docusign/archived-templates');
}

function archiveNdaTemplate(templateId: string) {
  return httpClient.post<NDATemplate>(
    `docusign/templates/${templateId}/archive`,
  );
}

function undoArchiveNdaTemplate(templateId: string) {
  return httpClient.post<NDATemplate>(
    `docusign/templates/${templateId}/undo-archive`,
  );
}

function removeNdaTemplate(templateId: string) {
  return httpClient.post<NDATemplate>(
    `docusign/templates/${templateId}/remove`,
  );
}

function undoRemoveNdaTemplate(templateId: string) {
  return httpClient.post<NDATemplate>(
    `docusign/templates/${templateId}/undo-remove`,
  );
}

function restoreNdaTemplate(templateId: string) {
  return httpClient.post<NDATemplate>(
    `docusign/templates/${templateId}/restore`,
  );
}

function undoRestoreNdaTemplate(templateId: string) {
  return httpClient.post<NDATemplate>(
    `docusign/templates/${templateId}/undo-restore`,
  );
}

function getPreviewForWatermark(params?: {
  watermarkDiagonal?: boolean;
  watermarkHeader?: boolean;
  watermarkFooter?: boolean;
  watermarkFullName?: boolean;
  watermarkEmail?: boolean;
  watermarkIpAddress?: boolean;
}) {
  return httpClient.post<FilePreview>(`generals/watermark-preview`, params);
}

export default {
  contactUs,
  referAFriend,
  getDocusignUrl,
  searchMarketPlace,
  searchDeals,
  getNdaTemplates,
  getArchivedNdaTemplates,
  getPreviewForWatermark,
  archiveNdaTemplate,
  undoArchiveNdaTemplate,
  removeNdaTemplate,
  undoRemoveNdaTemplate,
  restoreNdaTemplate,
  undoRestoreNdaTemplate,
};
